class DatagridsCheck {

    constructor(table) {
        this.table = table;
        if ($(table).data("DatagridsCheck")) return false;
        this.target = $(table.dataset.target);
        if (this.target.length === 0) return false;
        $(table).data("DatagridsCheck", this);
        this.list = [];
        this.init();
    }

    init() {
        var that = this;
        $(this.table).find('[data-check="all"]').click(function(e) {
            var input = e.target;
            $(input).parents("table").find('input[data-check="value"]').attr("checked", input.checked);
            if (input.checked) {
                var checked = $(input).parents("table").find('input[data-check="value"]');
                for (var i = 0; i < checked.length; i++) {
                    var value = checked[i].value;
                    if (that.list.indexOf(value) === -1) that.list.push(value);
                }
            } else {
                that.list = [];
            }
        });
        $(this.table).find('[data-check="value"]').click(function(e) {
            var input = e.target;
            if (input.checked) {
                if (that.list.indexOf(input.value) === -1) that.list.push(input.value);
            } else {
                that.list.splice(that.list.indexOf(input.value), 1);
            }
        });
        $(this.target).click(function(e) {
            e.preventDefault();
            var control = $(e.target);
            var ids = that.list;
            var form = document.createElement("form");
            form.method = "post";
            form.action = control.data("url");
            var hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = "ids";
            hiddenInput.value = JSON.stringify(ids);
            form.appendChild(hiddenInput);
            document.body.appendChild(form);
            form.submit();
        });
    }

}
